// reducers/kmcReducer.js
import {
  KMC_FETCH_PROPERTY_REQUEST,
  KMC_FETCH_PROPERTY_SUCCESS,
  KMC_FETCH_PROPERTY_FAILURE,
  KMC_INIT_PAYMENT_REQUEST,
  KMC_INIT_PAYMENT_SUCCESS,
  KMC_INIT_PAYMENT_FAILURE,
  KMC_APPLICATION_ENTRY_REQUEST,
  KMC_APPLICATION_ENTRY_SUCCESS,
  KMC_APPLICATION_ENTRY_FAILURE,
  KMC_WATER_TAX_REQUEST,
  KMC_WATER_TAX_SUCCESS,
  KMC_WATER_TAX_FAILURE,
  KMC_LICENSE_FEE_REQUEST,
  KMC_LICENSE_FEE_SUCCESS,
  KMC_LICENSE_FEE_FAILURE,
  KMC_GENERAL_DEMAND_REQUEST,
  KMC_GENERAL_DEMAND_SUCCESS,
  KMC_GENERAL_DEMAND_FAILURE,
  KMC_GRIEVANCE_DETAILS_REQUEST,
  KMC_GRIEVANCE_DETAILS_SUCCESS,
  KMC_GRIEVANCE_DETAILS_FAILURE,
  KMC_DEPARTMENT_REQUEST,
  KMC_DEPARTMENT_SUCCESS,
  KMC_DEPARTMENT_FAILURE,
  KMC_SUBCATEGORY_REQUEST,
  KMC_SUBCATEGORY_SUCCESS,
  KMC_SUBCATEGORY_FAILURE,
  KMC_SUBMIT_GRIEVANCE_REQUEST,
  KMC_SUBMIT_GRIEVANCE_SUCCESS,
  KMC_SUBMIT_GRIEVANCE_FAILURE,
} from "../actions/kmcAction";

const initialState = {
  kmc_loading: false,
  kmc_data: null,
  kmc_error: null,
  kmc_payment_loading: false,
  kmc_payment_data: null,
  kmc_payment_error: null,
  kmc_application_loading: false,
  kmc_application_data: null,
  kmc_application_error: null,
  kmc_water_tax_loading: false,
  kmc_water_tax_data: null,
  kmc_water_tax_error: null,
  kmc_license_fee_loading: false,
  kmc_license_fee_data: null,
  kmc_license_fee_error: null,
  kmc_general_demand_loading: false,
  kmc_general_demand_data: null,
  kmc_general_demand_error: null,
  kmc_grievance_loading: false,
  kmc_grievance_data: null,
  kmc_grievance_error: null,
  kmc_department_loading: false,
  kmc_department_data: null,
  kmc_department_error: null,
  kmc_subcategory_loading: false,
  kmc_subcategory_data: null,
  kmc_subcategory_error: null,
  kmc_submit_grievance_loading: false,
  kmc_submit_grievance_data: null,
  kmc_submit_grievance_error: null,
};

// ✅ Correct syntax for default export
const kmcReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Property ---
    case KMC_FETCH_PROPERTY_REQUEST:
      return { ...state, kmc_loading: true, kmc_error: null };
    case KMC_FETCH_PROPERTY_SUCCESS:
      return { ...state, kmc_loading: false, kmc_data: action.payload };
    case KMC_FETCH_PROPERTY_FAILURE:
      return { ...state, kmc_loading: false, kmc_error: action.payload };
    case "CLEAR_KMC_DATA":
      return { ...state, kmc_data: null };
    case "CLEAR_WATER_SERVICE_DATA":
      return { ...state, kmc_water_tax_data: null };
    // --- Payment ---
    case KMC_INIT_PAYMENT_REQUEST:
      return { ...state, kmc_payment_loading: true, kmc_payment_error: null };
    case KMC_INIT_PAYMENT_SUCCESS:
      return { ...state, kmc_payment_loading: false, kmc_payment_data: action.payload };
    case KMC_INIT_PAYMENT_FAILURE:
      return { ...state, kmc_payment_loading: false, kmc_payment_error: action.payload };

    // --- Application Entry ---
    case KMC_APPLICATION_ENTRY_REQUEST:
      return { ...state, kmc_application_loading: true, kmc_application_error: null };
    case KMC_APPLICATION_ENTRY_SUCCESS:
      return {
        ...state,
        kmc_application_loading: false,
        kmc_application_data: action.payload,
      };
    case KMC_APPLICATION_ENTRY_FAILURE:
      return {
        ...state,
        kmc_application_loading: false,
        kmc_application_error: action.payload,
      };
    // --- Water Tax Details ---
    case KMC_WATER_TAX_REQUEST:
      return { ...state, kmc_water_tax_loading: true, kmc_water_tax_error: null };

    case KMC_WATER_TAX_SUCCESS:
      return { ...state, kmc_water_tax_loading: false, kmc_water_tax_data: action.payload };

    case KMC_WATER_TAX_FAILURE:
      return { ...state, kmc_water_tax_loading: false, kmc_water_tax_error: action.payload };

    // --- Grievance Details ---
    case KMC_GRIEVANCE_DETAILS_REQUEST:
      return {
        ...state,
        kmc_grievance_loading: true,
        kmc_grievance_error: null,
      };

    case KMC_GRIEVANCE_DETAILS_SUCCESS:
      return {
        ...state,
        kmc_grievance_loading: false,
        kmc_grievance_data: action.payload,
      };

    case KMC_GRIEVANCE_DETAILS_FAILURE:
      return {
        ...state,
        kmc_grievance_loading: false,
        kmc_grievance_error: action.payload,
      };

    case "CLEAR_GRIEVANCE_DATA":
      return {
        ...state,
        kmc_grievance_data: null,
      };

    case KMC_DEPARTMENT_REQUEST:
      return { ...state, kmc_department_loading: true, kmc_department_error: null };
    case KMC_DEPARTMENT_SUCCESS:
      return { ...state, kmc_department_loading: false, kmc_department_data: action.payload };
    case KMC_DEPARTMENT_FAILURE:
      return { ...state, kmc_department_loading: false, kmc_department_error: action.payload };

    case KMC_SUBCATEGORY_REQUEST:
      return { ...state, kmc_subcategory_loading: true, kmc_subcategory_error: null };
    case KMC_SUBCATEGORY_SUCCESS:
      return { ...state, kmc_subcategory_loading: false, kmc_subcategory_data: action.payload };
    case KMC_SUBCATEGORY_FAILURE:
      return { ...state, kmc_subcategory_loading: false, kmc_subcategory_error: action.payload };

    case KMC_SUBMIT_GRIEVANCE_REQUEST:
      return { ...state, kmc_submit_grievance_loading: true, kmc_submit_grievance_error: null };
    case KMC_SUBMIT_GRIEVANCE_SUCCESS:
      return { ...state, kmc_submit_grievance_loading: false, kmc_submit_grievance_data: action.payload };
    case KMC_SUBMIT_GRIEVANCE_FAILURE:
      return { ...state, kmc_submit_grievance_loading: false, kmc_submit_grievance_error: action.payload };

    default:
      return state;

    // --- License Fee / License Payment Details ---
    case KMC_LICENSE_FEE_REQUEST:
      return {
        ...state,
        kmc_license_fee_loading: true,
        kmc_license_fee_error: null,
      };

    case KMC_LICENSE_FEE_SUCCESS:
      return {
        ...state,
        kmc_license_fee_loading: false,
        kmc_license_fee_data: action.payload,
      };

    case KMC_LICENSE_FEE_FAILURE:
      return {
        ...state,
        kmc_license_fee_loading: false,
        kmc_license_fee_error: action.payload,
      };

    case "CLEAR_LICENSE_FEE_DATA":
      return {
        ...state,
        kmc_license_fee_data: null,
      };
    // --- General Demand Service ---
    case KMC_GENERAL_DEMAND_REQUEST:
      return {
        ...state,
        kmc_general_demand_loading: true,
        kmc_general_demand_error: null,
      };

    case KMC_GENERAL_DEMAND_SUCCESS:
      return {
        ...state,
        kmc_general_demand_loading: false,
        kmc_general_demand_data: action.payload,
      };

    case KMC_GENERAL_DEMAND_FAILURE:
      return {
        ...state,
        kmc_general_demand_loading: false,
        kmc_general_demand_error: action.payload,
      };

    case "CLEAR_GENERAL_DEMAND_DATA":
      return {
        ...state,
        kmc_general_demand_data: null,
      };

  }
};

export default kmcReducer;
